import React, { useEffect, useState } from 'react';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import { useLocale } from '../../../i18n/LanguageContext';

export default function MenuItemRemoveIconButton(props) {
  const { t } = useLocale();
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleRemove = () => {
    props.onRemoveMenuItem();
    setOpen(false);
  };

  return (
    <div>
      <Tooltip key={'remove-menu-item'} title={t('menuItems.removeMenuItem')} placement="top-start" value="remove-menu-item">
              <IconButton 
                  data-testid="item-remove-id" 
                  color="default" 
                  onClick={handleClickOpen}>
                  <DeleteIcon />
              </IconButton>
            </Tooltip>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
            {t('menuItems.removeMenuItem')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {t('menuItems.removeMenuItemConfirm', { itemName: props.item?.name || '' })}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose} style={{ textTransform: 'none'}}>
            {t('kitchenMenus.cancel')}
          </Button>
          <Button onClick={handleRemove} autoFocus style={{ textTransform: 'none'}} variant='contained'>
            {t('kitchenMenus.yes')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
